import { matchPath } from 'react-router-dom';
import { useLocation } from 'react-router';

export const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath({ path: pattern, end: false }, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};
